//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: false
  },
  data: () => ({
    popupShow: this.value,
    emoji: ['&#x1f44a;', '&#x1f44c;', '&#x1f44d;', '&#x1f44e;', '&#x1f44f;', '&#x270a;', '&#x270c;', '&#x1f60d;', '&#x1f60f;', '&#x1f61d;', '&#x1f62d;', '&#x1f602;', '&#x1f603;', '&#x1f609;', '&#x1f612;', '&#x1f618;', '&#x1f621;', '&#x1f624;', '&#x1f630;', '&#x1f631;', '&#x1f633;', '&#x1f637;', '&#x2764;']
  }),
  methods: {
    // 插入表情符
    insertEmoji (e) {
      this.$emit('insert', e.target.innerHTML)
      // this.popupShow = false
    }
  },
  watch: {
    value (val) {
      this.popupShow = val
    },
    popupShow (val) {
      this.$emit('input', val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/emoji/index.vue